import {
    Breadcrumbs,
    Button,
    Chip,
    Collapse,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";

import React, { useContext, useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { emphasize, styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HomeIcon from "@mui/icons-material/Home";
import { MyContext } from "../../App";
import { deleteData, fetchDataFromApi } from "../../utils/api";

// ================= Breadcrumb =================
const StyledBreadcrumb = styled(Chip)(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[800],
    height: theme.spacing(3),
    color: theme.palette.text.primary,
}));

// ================= Component =================
const ProductTops = () => {
    const [producttopData, setProducttopData] = useState([]);
    const [openDropdown, setOpenDropdown] = useState({});

    // 🔥 single dialog for all deletes
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteAction, setDeleteAction] = useState(null);
    const [deleteText, setDeleteText] = useState("");

    const context = useContext(MyContext);

    // ================= Fetch =================
    useEffect(() => {
        window.scrollTo(0, 0);
        context.setProgress(20);

        fetchDataFromApi("/api/producttop").then((res) => {
            setProducttopData(res?.producttops || []);
            context.setProgress(100);
        });
    }, []);

    const refresh = () => {
        fetchDataFromApi("/api/producttop").then((res) =>
            setProducttopData(res?.producttops || [])
        );
    };

    const toggleDropdown = (productId) => {
        setOpenDropdown((prev) => ({ ...prev, [productId]: !prev[productId] }));
    };

    // ================= Ask delete =================
    const askDelete = (message, action) => {
        setDeleteText(message);
        setDeleteAction(() => action);
        setOpenDelete(true);
    };

    // ================= Confirm delete =================
    const confirmDelete = () => {
        if (deleteAction) deleteAction();
        setOpenDelete(false);
    };

    return (
        <div className="right-content w-100">
            {/* ================= Header ================= */}
            <div className="card shadow border-0 w-100 flex-row p-4">
                <h5 className="mb-0">Product Top List</h5>

                <div className="ml-auto d-flex align-items-center">
                    <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
                        <StyledBreadcrumb component="a"
                            href="#" label="Dashboard" icon={<HomeIcon fontSize="small" />} />
                        <StyledBreadcrumb label="Product Top" />
                    </Breadcrumbs>

                    <Link to="/productTop/add">
                        <Button className="btn-blue ml-3 pl-3 pr-3">Add Product Top</Button>
                    </Link>
                </div>
            </div>

            {/* ================= Table ================= */}
            <div className="card shadow border-0 p-3 mt-4">
                <div className="table-responsive mt-3">
                    <table className="table table-bordered v-align">
                        <thead className="thead-dark">
                            <tr>
                                <th>PRODUCT</th>
                                <th>CODE</th>
                                <th>TOPS</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            {producttopData.length > 0 ? (
                                producttopData.map((item) => (
                                    <React.Fragment key={item._id}>
                                        <tr>
                                            <td>{item.productId?.name}</td>
                                            <td>{item.productId?.code}</td>

                                            {/* -------- TOP LIST -------- */}
                                            <td>
                                                <Button variant="contained" onClick={() => toggleDropdown(item._id)}>
                                                    {openDropdown[item._id] ? "Hide Tops" : "Show Tops"}
                                                </Button>

                                                <Collapse in={openDropdown[item._id]}>
                                                    <table className="table mt-2">
                                                        <tbody>
                                                            {item.tops.map((top) => (
                                                                <tr key={top._id}>
                                                                    <td>{top.name?.name}</td>

                                                                    <td>
                                                                        <div className="actions d-flex align-items-center">
                                                                            <Button
                                                                                className="error"
                                                                                color="error"
                                                                                onClick={() =>
                                                                                    askDelete("Delete this Top?", () =>
                                                                                        deleteData(
                                                                                            `/api/producttop/${item.productId._id}/${top.name._id}`
                                                                                        ).then(() => {
                                                                                            context.setAlertBox({
                                                                                                open: true,
                                                                                                error: true,
                                                                                                msg: "Top Deleted!",
                                                                                            });
                                                                                            refresh();
                                                                                        })
                                                                                    )
                                                                                }
                                                                            >
                                                                                <MdDelete />
                                                                            </Button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </Collapse>
                                            </td>

                                            {/* -------- PRODUCT DELETE -------- */}
                                            <td>
                                                <div className="actions d-flex align-items-center">
                                                    <Button
                                                        className="error"
                                                        color="error"
                                                        onClick={() =>
                                                            askDelete("Delete entire Product Top?", () =>
                                                                deleteData(`/api/producttop/${item.productId._id}`).then(
                                                                    () => {
                                                                        context.setAlertBox({
                                                                            open: true,
                                                                            error: true,
                                                                            msg: "ProductTop Deleted!",
                                                                        });
                                                                        refresh();
                                                                    }
                                                                )
                                                            )
                                                        }
                                                    >
                                                        <MdDelete />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        No Product Tops Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ================= Single Delete Dialog ================= */}
            <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
                <DialogTitle>Confirm Delete</DialogTitle>

                <DialogContent>{deleteText}</DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDelete(false)}>Cancel</Button>
                    <Button color="error" variant="contained" onClick={confirmDelete}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ProductTops;
